import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Mobile <select> stand-in for the grouped side menu: each option's value
// is the destination URL, so navigating is just a Turbo visit.
export default class extends Controller {
  go(event) {
    const href = event.target.value
    if (href) Turbo.visit(href)
  }
}
